/**
 * Project Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.projectDetailFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += row.description;
    }
    return html;
};
